export const OPEN_WALLET_MODAL = "Connect_Wallet";
export const ACCEPT_TOS = "Accpet_TOS_Checkbox";
export const OPEN_ACCOUNT_MODAL = "wallet_modal";
export const OPEN_AUDIT_MODAL = "Audit_hyperlink";
export const CLOSE_WALLET_MODAL = "close_wallet_modal";
export const HANDLE_DISCONNECT = "Disconnect_wallet";
export const CLICK_TNC_LINK = "Read_Terms_of_services";

export const HANDLE_SWITCH_NETWORK = "handle_switch_network";
export const HANDLE_ACTIVATE = "wallet_connect_started";
export const ACTIVATE_SUCCESS = "Wallet_connect_successful";
export const ACTIVATE_FAILED = "Wallet_connect_failed";
export const HANDLE_APPROVE = "handle_approve";

export const TAB_CLICK = "tab_click";

export const FOCUS_INPUT_STAKE = "focus_input_stake";
export const CLICK_STAKE_ADD_TOKEN = "add_liquid_token";
export const SUBMIT_STAKE = "stake_cta";
export const CLICK_STAKE_INPUT_MAX = "max_stake";
export const CLICK_UNSTAKE_INPUT_MAX = "max_unstake";

export const SUBMIT_UNSTAKE = "unstake_cta";

export const CLICK_CLAIM_BTN = "Withdraw_cta";

export const COPY_ACCOUNT_ADDRESS = "Copy_Address";
export const VIEW_ADDRESS_ON_SCANNER = "Blockchain_explorer";
export const VIEW_TXN_ON_SCANNER = "Blockchain_explorer";
export const VIEW_PAST_TRANSACTIONS = "View_past_transactions";
export const CLEAR_PAST_TRANSACTIONS = "Clear_all_transactions";

export const VIEW_AUDIT_REPORT = "Audit_type";
export const VIEW_BUG_BOUNTY = "view_bug_bounty";

export const VIEW_DEFI_PAGE = "Defipage";

export const NETWORK_CHANGE = "Network_change";

export const CLICK_DEFI_PARTNER_LINK = "Defi";
export const CLICK_DEFI_PARTNER_CARD = "Defi_Carousel_strategy";
export const CLICK_DEFI_EXPLORE = "Defi_Carousel_CTA";

export const CLICK_STADER_LOGO = "Stader_logo";

export const CLICK_SWAP_ON_DEX = "click_swap_on_dex";
export const CLICK_COMMUNITY_LINK = "Join_our_community";
export const CLICK_SUBSCRIBE_LINK = "learn_more_marketing";

export const PURCHASE_EVENT = "purchase";
export const VIEW_CONTRACT = "Contract_address";

export const CLICK_DEFI_UNSTAKE = "click_defi_from_unstake";
export const PROCEED_UNSTAKE = "proceed_unstake";

// home page
export const PRIMARY_TABS = "primary_tabs";
export const STAKE_NOW_CTA = "stake_now_CTA";
export const MATICX_AUDIT = "maticx_audit";
export const MATICX_BUG_BOUNTY = "maticx_bug_bounty";
export const VIEW_OUR_PARTNERS = "view_our_partners";
export const MATICX_SOCIALS = "maticx_socials";
export const SUBSCRIBE_EMAIL = "subscribe_email";
export const SUBSCRIBE_PRIVACY = "subscribe_privacy";
export const LEARN_MORE = "Learn_more_blockchain";

export const TRANSACTION_SUCCESS = "transaction_successful";
export const STAKE_SUCCESS = "stake_successful";
export const TRANSACTION_FAILED = "transaction_failure";

export const VIEW_DEFI_STRATEGIES = "view_defi_strategies";
export const SUBSCRIBE_DEFI_STRATEGIES = "Newsletter";

// Filters
export const ALL_FILTER = "all_filter";
export const TAG_FILTER = "tag_filter";
export const CATEGORY_FILTER = "category_filter";

// DeFi Page
export const CLICK_DEFI_CATEGORY_INFO = "click_defi_category_info";

// Liquid staking options
export const EXPLORE_STAKING = "Explore_staking";

// Banner
export const VIEW_BANNER = "Banner";
export const BANNER_CTA = "Banner_cta";
export const CLOSE_BANNER = "Banner_close";
